<template>
  <!-- front -->
  <v-container>
    <v-row class="d-flex align-center">
      <v-col lg="6">
        <!-- post -->
        <Textpost>
          <template slot="post-avatar" lg="2">
            <v-img :src="user(social.authorId).profilePic"></v-img>
          </template>
          <template slot="username">{{user(social.authorId).username}}</template>
          <template slot="post-title">{{ social.title}}</template>
          <template slot="post-body">{{ social.text }}</template>
          <template slot="time">{{ social.date | date }}</template>

          <v-img contain v-if="social.imageUrl" :src="social.imageUrl !== '' ? social.imageUrl : false" slot="post-img"></v-img>

          <template slot="button">
            <v-btn @click="likeThisPost(social)" contain>
              <v-icon v-if="likedPosts(social.id)" class="mr-1" color="pink">mdi-heart</v-icon>
              <v-icon v-else class="mr-1">mdi-heart</v-icon>
              <span class="subheading mr-2">{{social.likes}}</span>
            </v-btn>
          </template>
        </Textpost>
      </v-col>

      <v-col>
        <v-card width="80%" height="50%">
          <v-list two-line>
            <v-list-item-group multiple>
              <template v-for="message in fetchComments" >
                <v-list-item :key="message.text">
                  <v-list-item-avatar>
                    <v-img :src="user(message.from).profilePic"></v-img>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-subtitle v-text="user(message.from).username"></v-list-item-subtitle>
                    <v-list-item-title v-text="message.text"></v-list-item-title>

                  </v-list-item-content>

                  <v-list-item-action>
                    <v-list-item-action-text></v-list-item-action-text>

                  </v-list-item-action>
                </v-list-item>


              </template>
            </v-list-item-group>

          </v-list>



          <!-- send comment -->
          <v-container class="d-flex align-end justify-center">
            <v-row>
              <v-col lg="8">
                <v-form>
                  <v-text-field
                  @keydown.enter.prevent="addCategory"
                  v-model="comment"
                  outlined
                  full-width
                  label="Comment"
                  type="text"
                  @keyup.enter="sendComment"
                  dense
                  ></v-text-field>
                </v-form>
              </v-col>

              <v-col lg="1" class="ml-n4">
                <v-btn @click="sendComment" icon color="teal" large>
                  <v-icon>mdi-send</v-icon>
                </v-btn>
              </v-col>

            </v-row>
          </v-container>

        </v-card>
      </v-col>
    </v-row>



  </v-container>
</template>

<script>
import Textpost from '@/components/Frontend/TextPost.vue'

export default {
  data: () => ({
    comment: ''
  }),
  props: ['id'],
  computed: {
    social() {
      let feed = this.$store.state.fetchFeed
      for (let fed in feed) {
        if (feed[fed].id === this.id) {
          //return feed[fed]
        }

      }
      return this.$store.state.currentPost
      //return {}
    },
    fetchComments() {
      // console.log('from: ', this.$store.state.postComments[0].from)
      return this.$store.state.postComments
    },
  },
  components: {
    Textpost,
  },
  methods: {
    user(social) {
      return this.$store.state.allUsers[social]
    },
    likedPosts() {
      return this.$store.state.postInteraction[this.id]
    },
    likeThisPost() {

      this.$store.dispatch('firebaseAddLikedPost', {
        id: this.id,
        likes: this.social.likes,
        liked: this.$store.state.postInteraction[this.id] !== true ? true : false,
        private: this.social.private,
        authorId: this.social.authorId
      })
      this.$store.dispatch('fetchFeed')
      this.$store.dispatch('fetchPrivateFeed')
      this.$store.dispatch('firebaseGetPostInteraction')
    },
    sendComment() {
      this.$store.dispatch('firebaseSendComment', {
        comment: {
          text: this.comment,
          from: this.$store.state.user.id
        },
        postId: this.id
      })
      this.clearMessage()
    },
    clearMessage() {
      this.comment = ''
    }
  },
  mounted() {
    this.$store.dispatch('fetchFeed')
    this.$store.dispatch('fetchPrivateFeed')
    this.$store.dispatch('firebaseGetPostComments', this.id)
    this.$store.dispatch('firebaseGetPost',this.id)

    this.$store.dispatch('firebaseGetDMs')
    this.$store.dispatch('firebaseGetFriends')
    this.$store.dispatch('firebaseGetPostInteraction')
    this.$store.dispatch('firebaseGetGroupChat')
    this.$store.dispatch('firebaseGetNotifications')
  },
  destroyed() {
    this.$store.dispatch('firebaseStopGettingComments', this.id)
  }
}
</script>

<style lang="css" scoped>
</style>
